import { ChangeEvent } from "react";

interface CheckboxProps {
  label?: string;
  id: string;
  name: string;
  checked?: boolean;
  onChange?: (string: string, isChecked: boolean) => void;
  disabled?: boolean;
  customLabelStyle?: string;
  customStyle?: string;
  title?: string;
  truntTitle?: string;
}

function CustomCheckBox({
  label,
  id,
  name,
  title,
  checked = false,
  onChange,
  disabled = false,
  customLabelStyle,
  customStyle,
  truntTitle,
}: CheckboxProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onChange?.(event.target.name, isChecked);
  };
  return (
    <div
      className={`custom-checkbox ${
        disabled ? "opacity-70" : ""
      } ${customStyle}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        className={disabled ? "cursor-not-allowed" : "cursor-pointer"}
      />
      <label
        title={truntTitle || title}
        htmlFor={name}
        className={`font-interMedium ${
          disabled ? "cursor-not-allowed text-gray-500" : "cursor-pointer"
        }`}
      >
        <span
          title={title}
          className={`custom-checkbox-label font-interMedium ${customLabelStyle}`}
        >
          {label}
        </span>
      </label>
    </div>
  );
}

export default CustomCheckBox;
